/*
 * Source : https://stackoverflow.com/questions/46240647/react-how-to-force-a-function-component-to-render/53837442#53837442
 * */
import { useState } from 'react';

export default function useForceUpdate() {
    // eslint-disable-next-line no-unused-vars
    const [value, setValue] = useState(0);
    return () => setValue((value) => value + 1);
}
